import React, { Dispatch, FC, SetStateAction } from 'react';

import Button, { BUTTON_TYPES, BUTTON_WIDTHS } from 'buyside/components/presentation/Button/button';

import { ideaCreateUpdateUrl } from 'buyside/util/urlHelper';

import styles from './writeupStyles.scss';

const WriteupAlerts: FC<{
  ideaId: string;
  setWriteupFieldsHidden: Dispatch<SetStateAction<boolean>>;
}> = ({ ideaId, setWriteupFieldsHidden }) => {
  return (
    <div className={styles.writeupAlerts}>
      <div className={styles.writeupAlert}>
        <div className={styles.writeupAlertContent}>
          <p>
            <strong>Add a material update to your original idea</strong>
          </p>
          <p>
            Adjust position details, price targets, add new catalysts, and provide updated
            information on your original idea. Adding a new update alerts your followers as well as
            your company's followers to the new information, and bumps your idea to the top of the
            research feed.
          </p>
        </div>
        <Button
          text="Add Idea Update"
          type={BUTTON_TYPES.PRIMARY}
          url={ideaCreateUpdateUrl(ideaId)}
          width={BUTTON_WIDTHS.FULL}
        />
      </div>
      <div className={styles.writeupAlert}>
        <div className={styles.writeupAlertContent}>
          <p>
            <strong>Make minor textual edits on your original thesis</strong>
          </p>
          <p>
            Editing your original thesis will not notify the SumZero buyside community or change the
            idea's position in the idea listing. To notify other members of the community and
            increase the prominence of your idea, please add an update using the "Add Idea Update"
            button above.
          </p>
          <p>
            Larger edits may require SumZero admin approval before you see your changes reflected on
            your idea.
          </p>
        </div>
        <Button
          onClick={() => setWriteupFieldsHidden(prev => !prev)}
          text="Edit Original Writeup"
          width={BUTTON_WIDTHS.FULL}
        />
      </div>
    </div>
  );
};

export default WriteupAlerts;
